/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_ListingsInputs */

const en_loading_listings = /** @type {(inputs: Loading_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syncing listings...`)
};

const id_loading_listings = /** @type {(inputs: Loading_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyinkronkan listing...`)
};

/** @type {(inputs: Loading_ListingsInputs) => LocalizedString} */
const es_loading_listings = en_loading_listings;

/** @type {(inputs: Loading_ListingsInputs) => LocalizedString} */
const fr_loading_listings = en_loading_listings;

/** @type {(inputs: Loading_ListingsInputs) => LocalizedString} */
const de_loading_listings = en_loading_listings;

/** @type {(inputs: Loading_ListingsInputs) => LocalizedString} */
const ja_loading_listings = en_loading_listings;

/** @type {(inputs: Loading_ListingsInputs) => LocalizedString} */
const zh_loading_listings = en_loading_listings;

/** @type {(inputs: Loading_ListingsInputs) => LocalizedString} */
const ar_loading_listings = en_loading_listings;

/** @type {(inputs: Loading_ListingsInputs) => LocalizedString} */
const it_loading_listings = en_loading_listings;

/** @type {(inputs: Loading_ListingsInputs) => LocalizedString} */
const ru_loading_listings = en_loading_listings;

/** @type {(inputs: Loading_ListingsInputs) => LocalizedString} */
const pt_loading_listings = en_loading_listings;

/** @type {(inputs: Loading_ListingsInputs) => LocalizedString} */
const ko_loading_listings = en_loading_listings;

/**
* | output |
* | --- |
* | "Syncing listings..." |
*
* @param {Loading_ListingsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const loading_listings = /** @type {((inputs?: Loading_ListingsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_ListingsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loading_listings(inputs)
	if (locale === "es") return es_loading_listings(inputs)
	if (locale === "fr") return fr_loading_listings(inputs)
	if (locale === "de") return de_loading_listings(inputs)
	if (locale === "ja") return ja_loading_listings(inputs)
	if (locale === "zh") return zh_loading_listings(inputs)
	if (locale === "ar") return ar_loading_listings(inputs)
	if (locale === "id") return id_loading_listings(inputs)
	if (locale === "it") return it_loading_listings(inputs)
	if (locale === "ru") return ru_loading_listings(inputs)
	if (locale === "pt") return pt_loading_listings(inputs)
	return ko_loading_listings(inputs)
});